var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0v2h3.59l-9.83 9.83 1.41 1.41L16 3.41V7h2V0m-2 16H2V2h7V0H2a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V9h-2v7z",
    fill: "#fff"
  })));
}

export default SvgIconExternalLink;